// theme constant
export const gridSpacing = 3;
export const drawerWidth = 230;
export const appDrawerWidth = 320;

export const role = ['admin', 'agent', 'driver'];
export const roles = {admin:'admin', agent: 'agent', driver: 'driver'};
